/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { getApiKeysUrl, getUsersApiKeysUrl } from '@modules/cloud-api/v1/urls'

import asyncRequest from '../asyncRequests'
import { FETCH_ALL_USERS_API_KEYS, FETCH_CURRENT_USER_API_KEYS } from '../../constants/actions'

export function fetchAllUsersApiKeys() {
  const url = getUsersApiKeysUrl()

  return asyncRequest({
    type: FETCH_ALL_USERS_API_KEYS,
    url,
  })
}

export function fetchCurrentUserApiKeys() {
  const url = getApiKeysUrl()

  return asyncRequest({
    type: FETCH_CURRENT_USER_API_KEYS,
    url,
  })
}
